// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"bb6e75b7","144":"bb6e75b7","265":"bb6e75b7","275":"24368f1a","280":"4c2fb057","287":"287757de","605":"bb6e75b7","651":"ad13d586","920":"cf840ef0","938":"7dff9e9d","974":"0ea50e8f"}[chunkId] + ".chunk.css";
};